import { render, staticRenderFns } from "./invoice-details.vue?vue&type=template&id=5c15ec62&scoped=true"
import script from "./invoice-details.vue?vue&type=script&lang=js"
export * from "./invoice-details.vue?vue&type=script&lang=js"
import style0 from "./invoice-details.vue?vue&type=style&index=0&id=5c15ec62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c15ec62",
  null
  
)

export default component.exports